export const MOCK_GAME_MODULES = {
    'wintermere': {
      id: 'wintermere',
      name: 'Frost and Bones: The Ruins of Castle Wintermere',
      description: 'A perfect first adventure for new adventurers...',
      scenes: JSON.stringify({
        tavern_entrance: {
          id: 'tavern_entrance',
          title: "The Frostfire Tavern",
          description: "The warm glow of the Frostfire Tavern beckons through the swirling snow. The establishment stands as a beacon of warmth and refuge in the small town of Winterhaven, its weathered sign creaking in the cold wind. The smell of mulled wine and roasted meat wafts through the air.",
          choices: [
            {
              id: 'enter_tavern',
              text: "Step inside the tavern",
              nextScene: 'tavern_interior'
            },
            {
              id: 'observe_town',
              text: "Look around the town first",
              nextScene: 'winterhaven_streets'
            }
          ]
        },
        tavern_interior: {
          id: 'tavern_interior',
          title: "Inside the Frostfire Tavern",
          description: "Warmth washes over you as you enter. A crackling fireplace dominates one wall, while patrons huddle around wooden tables sharing tales and warm drinks. The bartender, a sturdy woman with graying hair, watches you with interest. In one corner, an old man clutches a worn map, while nearby, a group of merchants discuss troubled trade routes.",
          choices: [
            {
              id: 'approach_bartender',
              text: "Approach the bartender",
              nextScene: 'talk_to_bartender',
              rewards: {
                experience: 10
              }
            },
            {
              id: 'talk_to_old_man',
              text: "Speak with the old man holding the map",
              nextScene: 'mysterious_map'
            },
            {
              id: 'listen_merchants',
              text: "Eavesdrop on the merchants",
              nextScene: 'merchant_troubles'
            },
            {
              id: 'return_outside',
              text: "Return to the street",
              nextScene: 'tavern_entrance'
            }
          ]
        },
        winterhaven_streets: {
          id: 'winterhaven_streets',
          title: "Streets of Winterhaven",
          description: "Snow-covered streets wind between sturdy wooden buildings. To the north, the ruins of Castle Wintermere loom against the gray sky. The town seems unusually quiet, with few people braving the cold. A notice board near the town square displays several weathered announcements.",
          choices: [
            {
              id: 'read_notices',
              text: "Read the notice board",
              nextScene: 'notice_board',
              rewards: {
                experience: 5
              }
            },
            {
              id: 'enter_tavern',
              text: "Head to the Frostfire Tavern",
              nextScene: 'tavern_entrance'
            },
            {
              id: 'approach_castle',
              text: "Walk toward Castle Wintermere",
              nextScene: 'castle_approach',
              requires: 'has_castle_map'
            }
          ]
        },
        talk_to_bartender: {
          id: 'talk_to_bartender',
          title: "The Bartender's Tale",
          description: "\"Welcome to the Frostfire,\" the bartender says, wiping a mug with a clean cloth. \"Not many new faces these days, what with all the strange happenings up at the castle. Name's Maren. What brings you to our frozen corner of the world?\"",
          choices: [
            {
              id: 'ask_castle',
              text: "Ask about the castle",
              nextScene: 'bartender_castle_info'
            },
            {
              id: 'ask_drink',
              text: "Order a drink (5 gold)",
              nextScene: 'order_drink',
              rewards: {
                items: [{ id: 'hot_mead', name: 'Hot Mead', type: 'consumable' }]
              }
            },
            {
              id: 'return_tavern',
              text: "Thank her and return to the tavern",
              nextScene: 'tavern_interior'
            }
          ]
        },
        mysterious_map: {
          id: 'mysterious_map',
          title: "The Map Keeper",
          description: "The old man looks up as you approach, his eyes bright with an almost feverish light. \"You... you look like someone who might understand,\" he whispers, spreading the map on the table. It shows detailed passages beneath Castle Wintermere, marked with strange symbols.",
          choices: [
            {
              id: 'accept_map',
              text: "Accept the map",
              nextScene: 'receive_map',
              rewards: {
                experience: 25,
                items: [{ id: 'castle_map', name: 'Castle Wintermere Map', type: 'quest' }]
              }
            },
            {
              id: 'decline_map',
              text: "Politely decline",
              nextScene: 'tavern_interior'
            }
          ]
        }
      }),
      recommendedPlayers: 1,
      minLevel: 1,
      maxLevel: 1,
      maxPartySize: 1,
      startingLevel: 1,
      difficulty: 'EASY',
      estimatedPlayTime: "1-2 hours",
      status: 'PUBLISHED',
      creatorId: 'system',
      version: '1.0.0',
      tags: ['Single Player', 'Beginner Friendly']
    }
  };


export const MOCK_GAME_STATE = {
  id: 'mock_game_state',
  gameModuleId: 'wintermere',
  currentScene: 'tavern_entrance',
  partyLeaderId: 'mock_character_id',
  state: JSON.stringify({
    storyFlags: [],
    inventory: [],
    playerChoices: []
  }),
  createdAt: new Date().toISOString(),
  updatedAt: new Date().toISOString()
};